module.exports = __webpack_public_path__ + "static/media/earlyTerminationIcon.0c8b7116.svg";